import React, { useRef } from 'react';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import LoadingAnimation from 'components/loading-animation';

import {
  BottomServiceWrapper,
  ButtonContainer,
  Container,
  Details,
  Heading,
  IconContainer
} from './styled';
import { BottomServiceVariants, IBottomServiceModeViewProps } from './types';

export const BottomServiceModeView = React.forwardRef<HTMLDivElement, IBottomServiceModeViewProps>(
  (
    {
      isLoading = false,
      variant = BottomServiceVariants.DEFAULT,
      heading,
      details,
      icon,
      buttonContentText,
      buttonContentIcon,
      onBottomServiceClick = () => {},
      onButtonClick = () => {},
      buttonDisabled = false,
      className = ''
    },
    ref
  ) => {
    const buttonRef = useRef<HTMLButtonElement>(null);
    const handleOnBottomServiceClick = React.useCallback(
      (e: React.MouseEvent) => {
        if (e.target !== buttonRef.current) {
          onBottomServiceClick();
        }
      },
      [onBottomServiceClick]
    );
    if (isLoading) {
      return (
        <Container variant={variant} className={className} ref={ref}>
          <LoadingAnimation fillColor={Styles.color.white} />
        </Container>
      );
    }
    let buttonVariant;
    switch (variant) {
      case BottomServiceVariants.IN_PROGRESS:
        buttonVariant = ActionButtonVariants.OUTLINE;
        break;
      case BottomServiceVariants.DEFAULT:
      default:
        buttonVariant = ActionButtonVariants.PRIMARY;
    }
    return (
      <Container
        variant={variant}
        className={className}
        ref={ref}
        data-testid="bottom-service"
        onClick={handleOnBottomServiceClick}
      >
        <BottomServiceWrapper>
          <IconContainer>{icon}</IconContainer>
          <Heading>{heading}</Heading>
          <Details>{details}</Details>
          {buttonContentText && (
            <ButtonContainer>
              <ActionButton
                variant={buttonVariant}
                size={ActionButtonSizes.SMALL}
                data-testid="bottom-service-button"
                onClick={onButtonClick}
                disabled={buttonDisabled}
                ref={buttonRef}
                startIcon={buttonContentIcon}
              >
                {buttonContentText}
              </ActionButton>
            </ButtonContainer>
          )}
        </BottomServiceWrapper>
      </Container>
    );
  }
);
